<template>
  <span class="esign-tag" :class="'esign-tag--' + computedTone">
    <slot>{{ value }}</slot>
  </span>
</template>

<script>
  // DTD Badge: small outlined pill for statuses in tables and detail pages.
  // The color follows the status text (Selesai = green, Ditolak = red, ...)
  // unless `tone` is given: success | warning | danger | info | neutral.
  const TONES = [
    ['neutral', /tidak aktif|nonaktif|draft|dibaca|^read$/i],
    ['danger', /tolak|gagal|failed|error|batal|unread|kedaluwarsa|expired/i],
    ['success', /selesai|finished|success|berhasil|aktif|disetujui|sesuai/i],
    ['warning', /proses|process|menunggu|pending|waiting|antri|queue|revisi/i],
  ]

  export default {
    name: 'EsignStatusTag',

    props: {
      value: { type: [String, Number, Boolean], default: '' },
      tone: { type: String, default: null },
    },

    computed: {
      computedTone () {
        if (this.tone) return this.tone
        const text = String(this.value == null ? '' : this.value).trim()
        const match = TONES.find(([, re]) => re.test(text))
        return match ? match[0] : 'info'
      },
    },
  }
</script>

<style>
/* DTD Badge: pill (radius 16), 1px semantic border, light fill, padding 8 x 12 at 30px */
.esign-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 3px var(--space-3, 12px);
  border-radius: var(--badge-radius, 16px);
  border: 1px solid transparent;
  font-size: var(--font-size-100, 12px);
  font-weight: var(--font-weight-medium, 500);
  line-height: 18px;
  white-space: nowrap;
  vertical-align: middle;
}

.esign-tag--success {
  color: var(--dtd-green-500);
  background: var(--dtd-green-50);
  border-color: var(--dtd-green-500);
}

.esign-tag--warning {
  color: var(--dtd-orange-700);
  background: var(--dtd-orange-50);
  border-color: var(--dtd-orange-500);
}

.esign-tag--danger {
  color: var(--dtd-red-700);
  background: var(--dtd-red-50);
  border-color: var(--dtd-red-500);
}

.esign-tag--info {
  color: var(--dtd-sky-700);
  background: var(--dtd-sky-50);
  border-color: var(--dtd-sky-500);
}

.esign-tag--neutral {
  color: var(--dtd-gray-500);
  background: var(--dtd-gray-50);
  border-color: var(--dtd-gray-400);
}
</style>
